import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PopupMessage {
  id: string;
  message: string;
  type: 'danger' | 'success' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  private messages = new BehaviorSubject<PopupMessage[]>([]);

  constructor() { }

  getMessages() {
    return this.messages.asObservable();
  }

  show(message: string, type: 'danger' | 'success' | 'warning' | 'info' = 'info', duration: number = 4000) {
    const id = Date.now().toString();
    const popupMessage: PopupMessage = {
      id,
      message,
      type,
      duration
    };

    const currentMessages = this.messages.value;
    this.messages.next([...currentMessages, popupMessage]);

    // Auto-remove after duration
    setTimeout(() => {
      this.remove(id);
    }, duration);
  }

  remove(id: string) {
    const currentMessages = this.messages.value;
    this.messages.next(currentMessages.filter(msg => msg.id !== id));
  }

  clear() {
    this.messages.next([]);
  }

  // Convenience methods
  showDanger(message: string, duration?: number) {
    this.show(message, 'danger', duration);
  }

  showSuccess(message: string, duration?: number) {
    this.show(message, 'success', duration);
  }

  showWarning(message: string, duration?: number) {
    this.show(message, 'warning', duration);
  }

  showInfo(message: string, duration?: number) {
    this.show(message, 'info', duration);
  }

  showError(message: string, duration?: number) {
    this.show(message, 'danger', duration);
  }
}
